import { render, staticRenderFns } from "./CallToActionsEdit.vue?vue&type=template&id=23377301"
import script from "./CallToActionsEdit.vue?vue&type=script&lang=js"
export * from "./CallToActionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports